import { useEffect, useState } from 'react'
import Main from './Main'
import LeftSide from '../Common/LeftSide'
import { LayoutThree, LayoutTwo, LayoutTwoR } from '../../Layout/CommonStyle'
import { useAppDispatch } from '../../../store'
import { setMenuIndex } from '../../../store/userSlice'
import { MenteeMenu } from '../../../models/Enums'
import RecentJobs from '../../Common/RecentJobs'
import TestList from '../../Common/TestList'

function MenteeTest() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setMenuIndex(MenteeMenu.TEST))
  }, [])

  return (
    <LayoutTwoR>
      <Main />
      {/* <TestList /> */}
      <RecentJobs />
    </LayoutTwoR>
  )
}

export default MenteeTest
